import { StoreType } from '@tock/shared/utils/connect';
import { dashboard } from 'types';

export const getFloorplanTablesFromTemplate = (state: StoreType) => {
  const floorplan = state.templateInfo.template.floorplan;
  return floorplan && floorplan.activeTable ? (floorplan.activeTable as dashboard.Table[]) : [];
};

export const getFloorplanTableCombinationsFromTemplate = (state: StoreType) => {
  const floorplan = state.templateInfo.template.floorplan;
  return floorplan && floorplan.tableCombination
    ? (floorplan.tableCombination as dashboard.TableCombination[])
    : [];
};

export const currentDragSelectionItemSelector = (state: StoreType) =>
  state.templateInfo.currentDragSelectionItem;

export const startDragSelectionItemSelector = (state: StoreType) =>
  state.templateInfo.dragSelectStartItem;

export const dragSelectStatusSelector = (state: StoreType) =>
  state.templateInfo.dragSelectInProgress;

export const selectedDynamicOptimizationTimeSelector = (state: StoreType) =>
  state.templateInfo.selectedDynamicOptimizationTimeBeforeServiceMinutes;
